import INCENTIVA_EXT_1 from "./INCENTIVA_EXT_1";

export default {
  INCENTIVA_EXT_1,
};
